const SettingValues = {
  formName: "Information Form.",
  sheetId: "1rNfIs-WYmG4H5_o3ypcoxGicbyob0nWr7Zm64jSvTeE",
};

export default SettingValues;
